export default __webpack_public_path__ + "static/media/BrainBreak cards100.e89909ea.png";